module.exports = __webpack_public_path__ + "static/media/cf3e115e0d9e8651523bfde6052a7b97 (1).25ff56f7.svg";